import { authorizedAxios } from "../../../Actions/AxiosActions";
import { ISafegraphLocation } from "../../../Models/ISafegraphLocation";
import { ISafegraphLocationVisitData } from "../../../Models/ISafegraphLocationVisitData";
import { IServiceResult } from "../../../Models/IServiceResult";
import { ISubmitMobilyticsJobRequest } from "../../../Models/Requests/ISubmitMobilyticsJobRequest";
import { ISafegraphLocationRequest } from "../Types/MobilyticsActionTypes";

interface ISafegraphLocationsByIdRequest {
    safegraphLocationIds: string[];
}

interface IGetLocationVisitsRequest {
    locationId: string;
    brandId: string;
}

export interface ISafegraphGetNearestLocationsRequest {
    ids: string[];
    latitude: number;
    longitude: number;
    excludeBrand: string;
}

export async function submitMobilyticsReport(
    request: ISubmitMobilyticsJobRequest
) {
    return await authorizedAxios("POST", "/services/gps/Mobilytics/submit", null, request);
}

export async function getSafeGraphLocation(request: ISafegraphLocationRequest): Promise<IServiceResult<ISafegraphLocation>> {
    return await authorizedAxios<IServiceResult<ISafegraphLocation>>("POST", "/Safegraph/GetLocationFromPoint", null, request);
}

export const getSafeGraphLocations = async (safegraphLocationIds: string[]): Promise<ISafegraphLocation[]> => {
    const request: ISafegraphLocationsByIdRequest = {
        safegraphLocationIds
    };

    const response = await authorizedAxios<IServiceResult<ISafegraphLocation[]>>("POST", "/Safegraph/BySafegraphLocationId", null, request);
    return response.data;
};

export const getNearestSafegraphLocationsByBrand = async (request: ISafegraphGetNearestLocationsRequest): Promise<ISafegraphLocation[]> => {
    const response = await authorizedAxios<IServiceResult<ISafegraphLocation[]>>("POST", "/Safegraph/NearestByBrand", null, request);
    return response.data;
};

export const getNearestSafegraphLocationsByCategory = async (request: ISafegraphGetNearestLocationsRequest): Promise<ISafegraphLocation[]> => {
    const response = await authorizedAxios<IServiceResult<ISafegraphLocation[]>>("POST", "/Safegraph/NearestByCategory", null, request);
    return response.data;
};

export const getLocationVisits = async (locationId: string, brandId: string): Promise<ISafegraphLocationVisitData> => {
    const request: IGetLocationVisitsRequest = {
        locationId,
        brandId,
    };
    const response = await authorizedAxios<IServiceResult<ISafegraphLocationVisitData>>("POST", "/Safegraph/GetLocationVisits", null, request);
    return response.data;
};